module.exports = __webpack_public_path__ + "static/media/paper-and-card.41c18320.svg";